import {useEffect, useState} from 'react';
import {SseTopics, useSSEContext} from "../context/SSEContext";

export function useTopicSSE(topic) {
    const {subscribe, unsubscribe, getLatestMessage} = useSSEContext()
    const [message, setMessage] = useState(() => topic === SseTopics.OnlineList ? [] : tryParseJson(getLatestMessage(topic)))

    function tryParseJson(data) {
        if (data) {
            try {
                return JSON.parse(data)
            } catch (err) {
                console.error('Invalid JSON from SSE:', data)
            }
        }
    }

    useEffect(() => {
        function handler(data) {
            const d = tryParseJson(data)
            if (topic === SseTopics.OnlineList) {
                setMessage(prev => [...prev.filter(i => i.serial !== d.serial), d])
            } else {
                setMessage(d)
            }
        }

        //console.log("Mount 1")
        subscribe(topic, handler)

        return () => {
            //console.log("Umount 1")
            unsubscribe(topic, handler)
        }
    }, [topic])

    return message
}
